import React from "react";
import Facilitationbannertwo from "../../AVHRBanner/Executivecoachingbannertwo.jpg";

import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import ExecutiveCoachingOne from "../../Images/ExecutiveCoachingOneimg.png";

function Facilitation() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const points = [
    "🧠 Deep Self-Awareness",
    "💖 Highly Improved Emotional Intelligence",
    "🗣️ Refined and Influential Communication Skills",
    "💪 Built Resilience through Stress Management",
    "🚀 Strong Sense of Self by Overcoming Limitations",
    "🧩 Strategic Thinking Abilities",
    "🎯 Improved Decision-Making",
    "🌟 Lead with Confidence and Impact",
    "🧠 Strengthen self-awareness, influence, and resilience",
    "🤝 Resolve conflict and work effectively in matrixed, ambiguous environments",
  ];

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        {/* <div className="relative banner" style={{height:"70vh"}}>
          <img
            src={Facilitationbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Our Services</p>

              <h1 className="career-library-heading">
                Executive Coaching
              </h1>
            </div>
          </div>
        </div> */}

        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={Facilitationbannertwo}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Our Services</p>

              <h1 className="career-library-heading">Executive Coaching</h1>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}
          >
            <h1 className="mb-2 avhrProject-h1">
              Become the Leader You Aspire to Be
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{ fontSize: "20px" }}>
              At AV-CS, our Executive Coaching empowers professionals like you
              to evolve into ‘Leader that you want to be’. Through one-on-one
              exclusive coaching by our globally experienced experts, we help
              unlock your full potential
            </p>
          </div>
        </div>

        {/* <div
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center px-6 py-10"
          style={{ backgroundColor: "#FEFDED" }}>
          
          <div>
            <h2 className="mb-4 avhrProject-h2">
              Choosing the right Outcomes for your team
            </h2>
            <p className="avhrProject-p">
              While planning your team development, consider the following
              <span className="font-semibold">factors</span> to enhance
              effectiveness.
            </p>
          </div>
        </div> */}

        <div
          className="grid align-items-center px-3 md:px-6 py-2"
          style={{ backgroundColor: "#FFE7C7" }}
        >
          <div className="col-12 md:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={ExecutiveCoachingOne}
              alt="TalentAccquistOn"
              className="w-full border-round-lg shadow-4"
            />
          </div>

          <div className="col-12 md:col-6">
            <h2 className="mb-2 avhrProject-h2 pl-4">What You Gain:</h2>
            <ul className="list-none pl-4">
              {points.map((point, idx) => (
                <li key={idx} className="flex items-start mb-4">
                  {/* <FaCheckCircle className="circelcolour mt-1 mr-2" /> */}
                  <span className="avhrProject-p">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* <div
          className="grid align-items-center px-3 md:px-6 py-2"
          style={{ backgroundColor: "#FEFDED" }}>
          <div className="col-12 lg:col-6">
            <div className="flex items-start gap-3 mb-2">
              <FaUsers className="circelcolour text-5xl mt-4" />
              <div>
                <h3 className=" mb-2 avhrProject-h3">
                  Improved Group Engagement
                </h3>
                <p className="avhrProject-p">
                  Participants become more active, involved, and motivated,
                  leading to better contributions and higher overall energy
                  within teams.
                </p>
              </div>
            </div>

            
            <div className="flex items-start gap-3 mb-2">
              <FaBullseye className="circelcolour text-5xl mt-4" />
              <div>
                <h3 className=" mb-2 avhrProject-h3">
                  Clearer Goal Definition
                </h3>
                <p className="avhrProject-p">
                  With structured guidance, teams gain a sharper understanding
                  of their objectives, resulting in more focused and strategic
                  action.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 mb-2">
              <FaClipboardCheck className="circelcolour text-5xl mt-4" />
              <div>
                <h3 className=" mb-2 avhrProject-h3">Ownership of Results</h3>
                <p className="avhrProject-p">
                  Individuals take accountability for their roles, showing
                  greater responsibility and pride in their contributions and
                  outcomes.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 mb-2">
              <FaLightbulb className="circelcolour text-5xl mt-4" />
              <div>
                <h3 className=" mb-2 avhrProject-h3">Shared Creativity</h3>
                <p className="avhrProject-p">
                  Diverse perspectives are encouraged and harnessed, leading to
                  innovative ideas and collaborative problem-solving.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 lg:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={FacilitationOneimg}
              alt="Outcomes Illustration"
              className="w-full border-round-lg shadow-4"
            />
          </div>
        </div> */}

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(45deg, #FF7A6A, #FFC266)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              Experience a transformational journey towards confident and
              effective leadership
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default Facilitation;
